import React from "react";
import { LongballLogo } from "../components/longball-logo/longball-logo";
import { ConfidenceBar } from "./confidence-bar";
import { BLACK, GRAY, GREEN, MLB_HEADSHOT, MLB_TEAM_LOGO } from "./constants";
import { Footer } from "./footer";

const BrandLockup = () => (
  <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
    <LongballLogo scale={0.4} />
    <div style={{ display: "flex", flexDirection: "column", lineHeight: 1 }}>
      <div style={{ color: BLACK, fontWeight: 900, fontSize: 15, letterSpacing: 0.5, fontFamily: "'Arial Black', Arial, sans-serif" }}>
        LONGBALL
      </div>
      <div style={{ color: GREEN, fontWeight: 800, fontSize: 11, letterSpacing: 3.5, marginTop: 3, fontFamily: "Arial, sans-serif" }}>
        LABS
      </div>
    </div>
  </div>
);

export const TitlePage = ({ data, playerId, playerName = data?.name }) => {
  if (!data || !playerId) return null;

  const statCards = [
    { label: "Almost home runs", value: data.actionItems,  highlight: true },
    { label: "Front Row Joes",   value: data.frontRowJoes, sub: "barely home runs" },
    { label: "No Doubters",      value: data.noDOubters,   sub: "400+ ft bombs" },
  ];

  return (
    <div style={{ width: 900, height: 900, position: "relative", overflow: "hidden", background: "#ffffff", fontFamily: "'Arial Black', Arial, sans-serif", display: "flex", flexDirection: "column" }}>
      <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: 5, background: GREEN }} />

      <div style={{ padding: "24px 32px 0", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <BrandLockup />
        <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
          <div style={{ textAlign: "right" }}>
            <div style={{ color: BLACK, fontWeight: 900, fontSize: 18, lineHeight: 1, letterSpacing: -0.5 }}>{playerName}</div>
            <div style={{ color: "rgba(0,0,0,0.4)", fontSize: 10, fontFamily: "Arial, sans-serif", marginTop: 2, display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 5 }}>
              {data.teamId && (
                <img src={MLB_TEAM_LOGO(data.teamId)} alt={data.team ?? ""} style={{ width: 16, height: 16, objectFit: "contain" }} />
              )}
              {data.team} · {data.position} · {data.season}
            </div>
          </div>
          <img
            src={MLB_HEADSHOT(playerId)}
            alt={playerName}
            style={{ width: 60, height: 60, borderRadius: "50%", objectFit: "cover", objectPosition: "50% 20%", border: `2px solid ${GREEN}`, background: "#e8e8e8" }}
          />
        </div>
      </div>

      <div style={{ margin: "20px 32px", height: 1, background: GRAY }} />

      <div style={{ padding: "0 32px 20px" }}>
        <div style={{ color: "rgba(0,0,0,0.4)", fontSize: 11, textTransform: "uppercase", letterSpacing: 2, fontFamily: "Arial, sans-serif", marginBottom: 8 }}>
          The bottom line
        </div>
        <div style={{ color: BLACK, fontSize: 22, fontWeight: 900, lineHeight: 1.2, letterSpacing: -0.5, maxWidth: 580 }}>
          {data.actionItems} of your fly balls died at the warning track this season.
          <span style={{ color: GREEN }}> LongBall Labs turns those into home runs.</span>
        </div>
      </div>

      <div style={{ padding: "0 32px", display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10 }}>
        {statCards.map(({ label, value, sub, highlight }) => (
          <div key={label} style={{
            background: highlight ? GREEN : "#f8fafc",
            border: `1px solid ${highlight ? "transparent" : "#e2e8f0"}`,
            borderRadius: 10,
            padding: "22px 20px", textAlign: "center",
          }}>
            <div style={{ color: highlight ? "rgba(255,255,255,0.85)" : "rgba(0,0,0,0.4)", fontSize: 9, fontWeight: 700, textTransform: "uppercase", letterSpacing: 1.5, fontFamily: "Arial, sans-serif", marginBottom: 4 }}>{label}</div>
            <div style={{ color: highlight ? "#ffffff" : BLACK, fontWeight: 900, fontSize: 56, lineHeight: 1, letterSpacing: -2 }}>{value}</div>
            <div style={{ color: highlight ? "rgba(255,255,255,0.7)" : "rgba(0,0,0,0.35)", fontSize: 10, fontFamily: "Arial, sans-serif", marginTop: 4 }}>{sub}</div>
          </div>
        ))}
      </div>

      <div style={{ padding: "22px 32px 0" }}>
        <div style={{ background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 12, padding: "22px 24px" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 18 }}>
            <div>
              <div style={{ color: GREEN, fontSize: 9, fontWeight: 700, textTransform: "uppercase", letterSpacing: 2, fontFamily: "Arial, sans-serif" }}>
                Projected HRs with LongBall Labs
              </div>
              <div style={{ color: BLACK, fontWeight: 900, fontSize: 14, marginTop: 4 }}>
                Confidence interval based on your batted ball data
              </div>
            </div>
            <div style={{ textAlign: "right" }}>
              <div style={{ color: GREEN, fontWeight: 900, fontSize: 36, lineHeight: 1, letterSpacing: -1 }}>{data.projLow}–{data.projHigh}</div>
              <div style={{ color: "rgba(0,0,0,0.4)", fontSize: 9, fontFamily: "Arial, sans-serif" }}>projected range</div>
            </div>
          </div>
          <ConfidenceBar data={data} />
        </div>
      </div>

      <div style={{ padding: "16px 32px 0", display: "flex", gap: 10 }}>
        <div style={{ flex: 1, background: "#f0fdf4", border: "1px solid #86efac", borderRadius: 10, padding: "14px 20px", display: "flex", alignItems: "center", gap: 16 }}>
          <div style={{ color: GREEN, fontWeight: 900, fontSize: 32, lineHeight: 1 }}>${data.moneyGained}M</div>
          <div>
            <div style={{ color: BLACK, fontSize: 12, fontWeight: 900 }}>Estimated value added</div>
            <div style={{ color: "rgba(0,0,0,0.4)", fontSize: 10, fontFamily: "Arial, sans-serif" }}>Contract value increase at ${data.hrValue}M per HR</div>
          </div>
        </div>
        <div style={{ flex: 1, background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 10, padding: "14px 20px", display: "flex", alignItems: "center", gap: 16 }}>
          <div style={{ color: BLACK, fontWeight: 900, fontSize: 32, lineHeight: 1 }}>+{data.projExpected - data.actualHR}</div>
          <div>
            <div style={{ color: BLACK, fontSize: 12, fontWeight: 900 }}>Expected additional HRs</div>
            <div style={{ color: "rgba(0,0,0,0.4)", fontSize: 10, fontFamily: "Arial, sans-serif" }}>vs. {data.actualHR} without optimization</div>
          </div>
        </div>
      </div>

      <Footer name={data.name} position={data.position} season={data.season} team={data.team} />
    </div>
  );
};
